import { localized } from "@msuite/ui/localization";
import { createColumnHelper, createMeta } from "@msuite/ui/table";
import { moment } from "@msuite/utils/date";
import { formatNumber } from "@msuite/utils/numbers";
import { guardString } from "@msuite/utils/strings";
import type { SuborderLoadCarrierListItem } from "@msuite/utils/types";

const columnHelper = createColumnHelper<SuborderLoadCarrierListItem>();

/**
 * The carriers attached to one round: what goes along, whether it has moved, and what the yard
 * holds.
 *
 * `bookedAt` is the column that separates a plan from a fact — a dash means the line is still a
 * promise the sign-off is going to act on, and the round can be edited without costing anything.
 * The yard balance sits beside it because the two are read against each other: "24 going along, 242
 * standing outside" is one thought.
 */
export const columns = [
	columnHelper.accessor("name", {
		id: "name",
		header: localized("stock.load_carrier"),
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor("quantity", {
		id: "quantity",
		header: localized("general.quantity"),
		cell: (cell) => formatNumber(cell.getValue(), "integer", 0),
		meta: createMeta({ isNumeric: true }),
	}),
	columnHelper.accessor("bookedAt", {
		id: "bookedAt",
		header: localized("stock.booked_at"),
		cell: (cell) => {
			const bookedAt = cell.getValue();
			if (!bookedAt) return guardString(null);
			return moment(bookedAt).shortFormat();
		},
	}),
	columnHelper.accessor("stockBalance", {
		id: "stockBalance",
		header: localized("stock.stock_balance"),
		cell: (cell) => formatNumber(cell.getValue(), "integer", 0),
		meta: createMeta({ isNumeric: true }),
	}),
];
